import React from "react";
import PanelLayout from "../../components/PanelLayout";
import {useAppDispatch} from "../../hook/useAppDispatch";
import {fetchUserInfo} from "../../store/userStore";

const Dashboard: React.FC = () => {
    const dispatch = useAppDispatch()
    dispatch(fetchUserInfo())

    return <PanelLayout/>

}

export default Dashboard